import { Pipe, PipeTransform } from '@angular/core';
import { parseISO } from 'date-fns';

@Pipe({
  name: 'toString',
  standalone: true,
})
export class ToStringPipe implements PipeTransform {
  transform(value: unknown, defaultValue = ''): string {
    return typeof value === 'string' ? value : defaultValue;
  }
}

@Pipe({
  name: 'toNumber',
  standalone: true,
})
export class ToNumberPipe implements PipeTransform {
  transform(value: unknown, defaultValue = 0): number {
    return typeof value === 'number' && !isNaN(value) ? value : defaultValue;
  }
}

@Pipe({
  name: 'toDate',
  standalone: true,
})
export class ToDatePipe implements PipeTransform {
  transform(value: unknown, defaultValue: Date | null = null): Date | null {
    if (value instanceof Date) {
      return value;
    } else if (typeof value === 'string') {
      return parseISO(value);
    }
    return defaultValue;
  }
}

@Pipe({
  name: 'toArray',
  standalone: true,
})
export class ToArrayPipe implements PipeTransform {
  transform(value: unknown, defaultValue: unknown[] = []): unknown[] {
    return Array.isArray(value) ? value : defaultValue;
  }
}
